import React from 'react';
import PropTypes from 'prop-types';
import { has, noop } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { InputDropDown, InputEmail, InputPhoneNumber, InputText, InputZipCode } from '@sm360/widget-commons-forms';

class FormBuilder extends React.Component {
    constructor(props) {
        super(props);

        const { inputParams } = this.props;

        this.state = {
            isValid: inputParams.isRequired ? !!inputParams.value : true,
            value: props.inputParams.value,
        };

        this.onChange = this.onChange.bind(this);
    }

    onChange(newValue, inputName) {
        const { inputParams, onChange } = this.props;
        const isValid = !inputParams.isRequired || !!newValue;

        this.setState({
            isValid,
            value: newValue,
        });

        onChange(newValue, inputName, isValid);
    }

    render() {
        const { inputParams, hasBeenSubmit, errorLabel } = this.props;
        const { isValid, value } = this.state;

        let options = [];
        if (has(inputParams, 'options')) {
            options = inputParams.options.map((option) => ({
                ...option,
                label: LocaleService.t(option.transKey),
            }));
        }

        const classNames = ['styled-placeholder', `${inputParams.classNames}`];

        switch (inputParams.inputType) {
            case 'phone':
                return (
                    <InputPhoneNumber
                        label={LocaleService.t(inputParams.transKey)}
                        name={inputParams.inputName}
                        type="phone"
                        classNames={classNames}
                        isRequired={inputParams.isRequired}
                        valueChange={(changedValue) =>
                            this.onChange(changedValue.value, changedValue.name, changedValue.validation)
                        }
                        value={value}
                        isValid={isValid}
                        hasBeenSubmit={hasBeenSubmit}
                        errorLabel={LocaleService.t(errorLabel)}
                    />
                );
            case 'postalCode':
                return (
                    <InputZipCode
                        classNames={classNames}
                        label={LocaleService.t(inputParams.transKey)}
                        value={value}
                        isValid={isValid}
                        isRequired={inputParams.isRequired}
                        hasBeenSubmit={hasBeenSubmit}
                        onChange={(changedValue) =>
                            this.onChange(changedValue.value, inputParams.inputName, changedValue.validation)
                        }
                        errorLabel={LocaleService.t(errorLabel)}
                    />
                );
            case 'email':
                return (
                    <InputEmail
                        label={LocaleService.t(inputParams.transKey)}
                        classNames={classNames}
                        isRequired={inputParams.isRequired}
                        valueChange={this.onChange}
                        value={value}
                        hasBeenSubmit={hasBeenSubmit}
                        isValid={isValid}
                        errorLabel={LocaleService.t(errorLabel)}
                    />
                );
            case 'dropdown':
                return (
                    <InputDropDown
                        options={options}
                        errorLabel={LocaleService.t(errorLabel)}
                        placeholder={LocaleService.t(inputParams.transKey)}
                        name={inputParams.inputName}
                        classNames={['input-dropdown'].concat(inputParams.classNames)}
                        isRequired={inputParams.isRequired}
                        valueChange={(changedValue) => this.onChange(changedValue.value, inputParams.inputName, true)}
                        value={value}
                        hasBeenSubmit={hasBeenSubmit}
                        isValid={isValid}
                    />
                );
            case 'subhead':
                return (
                    <div className="clearfix">
                        <h4 className="sr-text is-bold">{LocaleService.t(inputParams.transKey)}</h4>
                    </div>
                );
            default:
                return (
                    <InputText
                        label={LocaleService.t(inputParams.transKey)}
                        errorLabel={LocaleService.t(errorLabel)}
                        name={inputParams.inputName}
                        type={inputParams.inputType}
                        classNames={classNames}
                        isRequired={inputParams.isRequired}
                        valueChange={this.onChange}
                        value={value}
                        hasBeenSubmit={hasBeenSubmit}
                        isValid={isValid}
                    />
                );
        }
    }
}

FormBuilder.defaultProps = {
    onChange: noop,
};

FormBuilder.propTypes = {
    inputParams: PropTypes.shape({
        inputName: PropTypes.string,
        transKey: PropTypes.string.isRequired,
        inputType: PropTypes.string.isRequired,
        classNames: PropTypes.string,
        isRequired: PropTypes.bool,
        options: PropTypes,
        value: PropTypes,
        placeholder: PropTypes,
    }).isRequired,
    onChange: PropTypes.func,
    hasBeenSubmit: PropTypes.bool,
    errorLabel: PropTypes.string,
};

FormBuilder.defaultProps = {
    onChange: noop,
    hasBeenSubmit: false,
    errorLabel: '',
};

FormBuilder.displayName = 'FormBuilder';

export default FormBuilder;
